<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="popup1" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
        </div>
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="body">
            <div class="top">
                <div class="t_left">
                    <img :src="webImg + info.logo" />
                    <div v-if="bzrFlag == 1">班主任</div>
                </div>
                <div class="t_right">
                    <div class="tr_left">
                        <div>{{ info.name }}</div>
                        <div>老师{{ teacherNum }}人 | 学生{{ stuNum }}人 | 班级号：{{ info.mihuaNo }}</div>
                    </div>
                    <div class="tr_right" @click="$router.go(-1)">
                        <img src="../../assets/img/i17.png" />
                        切换班级
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="c_left">
                    <div>我的课堂</div>
                    <div>总数：{{ courseNum }}</div>
                </div>
                <div class="c_right" @click="createClassRoom">新建课堂</div>
            </div>
            <div class="bottom">
                <div class="b_top">
                    <div>课题</div>
                    <div>学科</div>
                    <div>状态</div>
                    <div>分析状态</div>
                    <div>二维码</div>
                    <div>课堂编码</div>
                    <div>创建时间</div>
                    <div>操作</div>
                </div>
                <div class="b_bottom" :infinite-scroll-distance="50" :infinite-scroll-immediate="false"
                    v-infinite-scroll="load">
                    <div class="bb_item" v-for="(item, index) in list" :key="index">
                        <div class="bb_1">{{ item.courseName }}</div>
                        <div class="bb_2">{{ item.subjectName }}</div>
                        <div class="bb_3">
                            <div>{{ item.status == 0 ? '上课中' : item.status == 1 ? '结课' : '未上课' }}</div>
                        </div>
                        <div class="bb_4">
                            <!-- 评价状态 0-未评价 1-评价中 2-评价成功 3-评价失败 -->
                            <div>{{ item.evaluateStatus == 0 ? '未评价' : item.evaluateStatus == 1 ? '评价中' :
                                item.evaluateStatus
                                    == 2 ? '评价成功' : '评价失败' }}</div>
                        </div>
                        <div class="bb_5">
                            <el-image class="b5img" :src="webImg + item.qrCode"
                                :preview-src-list="[webImg + item.qrCode]"></el-image>
                        </div>
                        <div class="bb_2">{{ item.id }}</div>
                        <div class="bb_7">{{ item.createTime }}</div>
                        <div class="bb_8">
                            <div class="bb8_btn1"
                                @click="$router.push({ path: '/classroomInfo', query: { id: item.id } })">课堂管理</div>
                            <!-- btn_edit(item, index) -->
                            <div class="bb8_btn1" @click="btn_edit(item,index)">修改</div>
                            <template>
                                <el-popconfirm title="是否确定删除该课堂？" @confirm="btn_del(item.id)">
                                    <el-button type="text" class="bb8_btn2" slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                </div>
            </div>
        </div>
        <div class="addClass" v-if="flag">
            <div class="ac_title">
                <div>编辑课堂</div>
                <img src="../../assets/img/i18.png" @click="flag = false" />
            </div>
            <div class="ac_content">
                <div class="acc_input">
                    <div class="cci_left"><span>*</span>课题名称：</div>
                    <input placeholder="课题名称请认真填写，否则会影响后续智能体数据判断" v-model="courseName" />
                </div>
                <div class="acc_input">
                    <div class="cci_left"><span>*</span>学科名称：</div>
                    <input placeholder="请输入..." v-model="subjectName" />
                </div>
                <div class="acc_line"></div>
                <div class="acc_select">
                    <div class="ccs_tit"><span>*</span>智能体选择：</div>
                    <div class="ccs_box">
                        <div class="csb_list">
                            <div class="sbl_tit">
                                <div class="blt_left">待选择</div>
                                <div class="blt_right">
                                    <div :class="type == 1 ? 'ltr' : ''" @click="btn_type(1)">官方</div>
                                    <div :class="type == 2 ? 'ltr' : ''" @click="btn_type(2)">个人</div>
                                </div>
                            </div>
                            <div class="sbl_list">
                                <div class="bll_item" :title="item.helperName"
                                    v-for="(item, index) in filteredAvailableItems" :key="index"
                                    @click="btn_selectAdd(item, index)">
                                    <img class="lli_left"
                                        :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                    <div class="lli_right">
                                        <img class="lir_left" :src="webImg + item.icon" />
                                        <div class="lir_right">
                                            <div class="line1_">{{ item.helperName }}</div>
                                            <div class="line1_">{{ item.note }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sbl_btn">
                            <div class="blb_btn1" @click="addItems">添加</div>
                            <div class="blb_btn2" @click="removeItems">移除</div>
                        </div>
                        <div class="csb_list">
                            <div class="sbl_tit">已选择（{{ selectedItems.length }}）</div>
                            <div class="sbl_list">
                                <div class="bll_item" :title="item.helperName" v-for="(item, index) in selectedItems"
                                    :key="index" @click="btn_selectRemove(item, index)">
                                    <img class="lli_left"
                                        :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                    <div class="lli_right">
                                        <img class="lir_left" :src="webImg + item.icon" />
                                        <div class="lir_right">
                                            <div class="line1_">{{ item.helperName }}</div>
                                            <div class="line1_">{{ item.note }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ccs_bottom">
                        <div class="csb_btn" @click="flag = false">取消</div>
                        <div class="csb_btn1" @click="submit">提交</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    classInfo,
    checkPermi,
    classStudentList,
    classCourseList,
    courseAdd,
    techHelperOption,
    courseDetail,
    courseEdit,
    courseRemove
} from '@/apis/index'
// import { get } from 'lodash';
export default {
    data() {
        return {
            flag: false,
            classId: this.$route.query.id,
            info: {},
            bzrFlag: '',
            stuNum: 0,
            teacherNum: 0,
            techSectionId: '',
            courseNum: 0,
            availableItems: [],//可添加的项目列表
            selectedItems: [],//已添加的项目列表
            selectedAvailable: [], //存储选中的项目用于存储当前选中的项目
            selectedSelected: [],//用于存储当前选中的项目
            courseName: '',
            subjectName: '',
            list: [],
            ktId: '',
            pageNum: 1,
            courseType: 1,
            isPersonal: 0,
            type: 1,
            isTeacher:this.$route.query.isTeacher
        }
    },
    mounted() {
        if (this.$route.query.flag) {
            this.flag = true
            const query = { ...this.$route.query }; // 复制当前查询参数
            delete query.flag; // 删除 id 参数

            this.$router.push({
                path: this.$route.path,
                query
            });
        }
        if (this.classId) {
            this.getClassInfo()
        }
    },
    computed: {
        // 新增过滤条件：根据type筛选且排除已选数据
        filteredAvailableItems() {
            return this.availableItems.filter(item => {
                const typeMatch = this.type == 1 ? item.isPersonal == null : item.isPersonal != null
                return !item.ifChoose && typeMatch
            })
        }
        // filteredAvailableItems() {
        //     if (this.type == 1) {
        //         return this.availableItems.filter(item => item.isPersonal == null)
        //     } else if (this.type == 2) {
        //         return this.availableItems.filter(item => item.isPersonal != null)
        //     }
        //     return this.availableItems
        // }
    },
    methods: {
        btn_type(type) {
            this.type = type
        },
        createClassRoom() {
            // this.flag = true
            this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: this.ktId,techClassId:this.classId,courseType:this.courseType } })
            // this.ktId = ''
            // this.type = 1
            // this.availableItems = []
            // this.selectedItems = []
            // this.selectedSelected = []
            // this.selectedAvailable = []
            // this.getTechHelperOption()
        },
        load() {
            this.throttle(() => {
                if (this.courseNum > this.list.length) {
                    this.pageNum++
                    this.getClassCourseList()
                }
            })
        },
        btn_del(ktId) {
            this.throttle(() => {
                courseRemove(ktId).then(res => {
                    console.log(res)
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getClassInfo()
                })
            })
        },
        btn_edit(item, index) {
            // this.ktId = item.id
            // this.subjectName = item.subjectName
            // this.courseName = item.courseName
            // this.availableItems = []
            // this.selectedItems = []
            // this.selectedSelected = []
            // this.selectedAvailable = []
            // this.getTechHelperOption()
            // this.flag = true

            this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: item.id,techClassId:this.classId,courseType:this.courseType,courseName:item.courseName,subjectName:item.subjectName } })
        },
        submit() {
            this.throttle(() => {
                let loading = this.$loading({
                    lock: true,
                    text: "正在保存中，请稍候...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                if (this.courseName == '') {
                    this.$message({
                        message: '请输入课题名称',
                        type: 'warning'
                    });
                    return
                }
                if (this.subjectName == '') {
                    this.$message({
                        message: '请输入学科名称',
                        type: 'warning'
                    });
                    return
                }
                if (this.selectedItems.length == 0) {
                    this.$message({
                        message: '请选择智能体',
                        type: 'warning'
                    });
                    return
                }
                this.selectedItems.forEach(e => { e.ifChoose = true })
                if (this.ktId) {
                    courseEdit({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        subjectName: this.subjectName,
                        techClassId: this.classId,
                        id: this.ktId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.flag = false
                        this.$router.push({ path: '/classroomInfo', query: { id: this.ktId } })
                        this.ktId = ''
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    courseAdd({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        subjectName: this.subjectName,
                        techClassId: this.classId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.flag = false
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        // this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: res.data } })
                        // this.$router.push({ path: '/classroomInfo', query: { id: res.data } })
                    }).finally(() => {
                        loading.close();
                    })
                }
            })
        },
        btn_selectRemove(item, index) {
            this.throttle(() => {
                item.select = item.select == 0 ? 1 : 0
                if (item.select == 1) {
                    this.selectedSelected.push(item)
                } else {
                    this.selectedSelected.splice(index, 1)
                }
            }, 500)
        },
        btn_selectAdd(item, index) {
            this.throttle(() => {
                item.select = item.select == 0 ? 1 : 0
                if (item.select == 1) {
                    this.selectedAvailable.push(item)
                } else {
                    this.selectedAvailable.splice(index, 1)
                }
            }, 500)
        },
        // // 添加选中项方法
        addItems() {
            this.throttle(() => {
                this.selectedAvailable.forEach(e => { e.select = 0 })
                this.selectedItems.push(...this.selectedAvailable);
                this.availableItems = this.availableItems.filter(item => !this.selectedAvailable.includes(item));
                this.selectedAvailable = [];
            }, 500)
        },
        // // 移除选中项方法

        removeItems() {
            this.throttle(() => {
                const removedIds = new Set(this.selectedSelected.map(item => item.id))

                // 更新数据源状态
                this.availableItems = [
                    ...this.availableItems,
                    ...this.selectedSelected.map(item => ({ ...item, ifChoose: false }))
                ]

                // // 更新右侧列表
                this.selectedItems = this.selectedItems.filter(item => !this.selectedSelected.includes(item));
                // this.selectedItems = this.selectedItems.filter(item =>
                //     !removedIds.has(item.id)
                // )
                this.selectedSelected = []
                this.availableItems.forEach(e => { e.select = 0 })
            }, 500)
        },
        // removeItems() {
        //     this.throttle(() => {
        //         this.selectedSelected.forEach(e => { e.select = 0 })
        //         this.availableItems.push(...this.selectedSelected);
        //         this.selectedItems = this.selectedItems.filter(item => !this.selectedSelected.includes(item));
        //         this.selectedSelected = [];
        //     }, 500)
        // },
        // 获取课堂智能体接口
        getTechHelperOption() {
            // createBy空的就是官方的智能体
            techHelperOption(this.courseType, this.ktId).then(res => {
                console.log(res, 'techHelperOption');
                res.data.forEach(item => {
                    item.select = 0
                    if (item.ifChoose) {
                        this.selectedItems.push(item)
                    } else {
                        console.log(item, 'item');

                        this.availableItems.push(item)
                    }
                })
                this.availableItems = res.data
            });
        },
        getClassCourseList() {
            classCourseList(this.classId, this.pageNum, this.courseType,this.isTeacher).then(res => {
                console.log(res, 'classCourseList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.list = [...this.list, ...res.data]
                this.courseNum = res.total
            });
        },
        getClassStudentList() {
            classStudentList(this.classId).then((res) => {
                console.log(res, 'classStudentList');
                this.stuNum = res.data.length;
            });
        },
        getCheckPermi() {
            checkPermi(this.classId).then((res) => {
                console.log(res, 'checkPermi');
                this.bzrFlag = res.data;
            });
        },
        getClassInfo() {
            classInfo(this.classId).then(res => {
                console.log(res)
                this.info = res.data
                this.teacherNum = res.data.teacherNum;
                this.techSectionId = res.data.techSectionId
                this.pageNum = 1
                this.getCheckPermi()
                this.getClassStudentList()
                this.getClassCourseList()
                this.getTechHelperOption()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.line2_ {
    word-break: break-all;
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .popup1 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 2;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .addClass {
        width: 972px;
        height: 650px;
        background: #FFFFFF;
        border-radius: 10px;
        position: absolute;
        top: 370px;
        /* 距离顶部 50% */
        left: 50%;
        /* 距离左侧 50% */
        transform: translate(-50%, -50%);
        z-index: 3;

        .ac_title {
            width: 100%;
            height: 42px;
            border-radius: 10px 10px 0 0;
            background: #F4F6FB;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 20px;

            div {
                font-weight: bold;
                font-size: 18px;
                color: #000000;
            }

            img {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .ac_content {
            width: 100%;

            .acc_input {
                width: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 0 210px 0 30px;
                margin-top: 15px;

                .cci_left {
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    width: 130px;
                    text-align: right;

                    span {
                        font-weight: bold;
                        font-size: 14px;
                        color: #FF0000;
                        margin-right: 4px;
                    }
                }

                input {
                    flex: 1;
                    margin-left: 10px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #CED4DB;
                    box-sizing: border-box;
                    padding: 0 8px;
                }
            }

            .acc_line {
                width: 100%;
                height: 1px;
                background-color: #ECECEC;
                margin: 20px 0;
            }

            .acc_select {
                width: 100%;

                .ccs_tit {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 210px 0 75px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    margin-bottom: 15px;

                    span {
                        font-weight: bold;
                        font-size: 14px;
                        color: #FF0000;
                        margin-right: 4px;
                    }
                }

                .ccs_box {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .csb_list {
                        width: 280px;
                        height: 350px;
                        border-radius: 8px 8px 8px 8px;
                        border: 1px solid #F0F0F0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .sbl_tit {
                            width: 100%;
                            height: 35px;
                            border-bottom: 1px solid#ECECEC;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            line-height: 35px;
                            box-sizing: border-box;
                            padding: 0 20px;
                            padding-right: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .blt_right {
                                width: 110px;
                                height: 25px;
                                border: 1px solid#9EA3A7;
                                border-radius: 8px 8px 8px 8px;
                                display: flex;
                                align-items: center;
                                overflow: hidden;

                                .ltr {
                                    background-color: #399AFF !important;
                                    color: #fff !important;
                                }

                                div {
                                    flex: 1;
                                    text-align: center;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #333333;
                                    cursor: pointer;
                                }
                            }
                        }

                        .sbl_list::-webkit-scrollbar {
                            display: none;
                        }

                        .sbl_list {
                            width: 100%;
                            height: 0;
                            flex: 1;
                            overflow-y: scroll;

                            .bll_item {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                box-sizing: border-box;
                                padding: 0 20px;
                                margin-top: 15px;
                                cursor: pointer;

                                .lli_left {
                                    width: 14px;
                                    height: 14px;
                                }

                                .lli_right {
                                    flex: 1;
                                    display: flex;
                                    align-items: center;
                                    margin-left: 15px;

                                    .lir_left {
                                        width: 36px;
                                        height: 36px;
                                    }

                                    .lir_right {
                                        flex: 1;
                                        margin-left: 8px;

                                        div:nth-child(1) {
                                            font-weight: 500;
                                            font-size: 16px;
                                            color: #000000;
                                        }

                                        div:nth-child(2) {
                                            font-weight: 500;
                                            font-size: 12px;
                                            color: #999999;
                                            margin-top: 4px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .sbl_btn {
                        margin: 0 30px;

                        .blb_btn1 {
                            width: 64px;
                            height: 36px;
                            background: #399AFF;
                            border-radius: 8px 8px 8px 8px;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;
                            text-align: center;
                            line-height: 36px;
                            cursor: pointer;

                        }

                        .blb_btn2 {
                            width: 64px;
                            height: 36px;
                            background: #F75A5A;
                            border-radius: 8px 8px 8px 8px;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;
                            text-align: center;
                            line-height: 36px;
                            margin-top: 30px;
                            cursor: pointer;

                        }
                    }
                }

                .ccs_bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 20px;

                    .csb_btn {
                        width: 164px;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        border: 1px solid #399AFF;
                        font-weight: bold;
                        font-size: 16px;
                        color: #399AFF;
                        text-align: center;
                        line-height: 40px;
                        margin: 0 7px;
                        cursor: pointer;
                    }

                    .csb_btn1 {
                        width: 164px;
                        height: 40px;
                        background: #399AFF;
                        border-radius: 8px 8px 8px 8px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 40px;
                        margin: 0 7px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.back {
    width: 1200px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    // margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
    box-sizing: border-box;

    img {
        width: 14px;
        height: 14px;

    }
}

.body {
    width: 1200px;
    height: 96%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .top {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 20px;

        .t_left {
            position: relative;
            width: 100px;
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background-color: #c2c2c2;
            }

            div {
                width: 54px;
                height: 22px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #2992FF;
                font-weight: 500;
                font-size: 14px;
                color: #2992FF;
                text-align: center;
                line-height: 22px;
                position: absolute;
                bottom: -6px;
            }
        }

        .t_right {
            flex: 1;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tr_left {

                div:nth-child(1) {
                    font-weight: bold;
                    font-size: 28px;
                    color: #000000;
                    margin-bottom: 18px;
                }

                div:nth-child(2) {
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                }
            }

            .tr_right {
                width: 130px;
                height: 36px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #FFFFFF;
                font-weight: 800;
                font-size: 16px;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
            }
        }
    }

    .center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 40px 0;

        .c_left {
            display: flex;
            align-items: center;

            div:nth-child(1) {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-right: 20px;
            }

            div:nth-child(2) {
                font-weight: 500;
                font-size: 14px;
                color: #999999;
            }
        }

        .c_right {
            width: 104px;
            height: 36px;
            background: #399AFF;
            border-radius: 8px 8px 8px 8px;
            font-weight: 800;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
        }
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;

        .b_top {
            width: 100%;
            height: 42px;
            border-radius: 4px;
            background: #F4F6FB;
            display: flex;
            align-items: center;

            div {
                box-sizing: border-box;
                padding: 0 10px;
                text-align: center;
            }

            div:nth-child(1) {
                // width: 180px;
                flex: 2;
            }

            div:nth-child(2) {
                // width: 120px;
                flex: 1;
            }

            div:nth-child(3) {
                // width: 80px;
                flex: 1;
            }

            div:nth-child(4) {
                // width: 80px;
                flex: 1;
            }

            div:nth-child(5) {
                // width: 80px;
                flex: 1;
            }

            div:nth-child(6) {
                // width: 260px;
                flex: 1;
            }

            div:nth-child(7) {
                // width: 180px;
                flex: 2;
            }

            div:nth-child(8) {
                // width: 220px;
                flex: 2;
            }
        }

        .b_bottom::-webkit-scrollbar {
            display: none;
        }

        .b_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;

            .bb_item {
                width: 100%;
                height: 78px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid#F2F3F5;

                div {
                    box-sizing: border-box;
                    padding: 0 10px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .bb_1 {
                    flex: 2;
                    // width: 180px;
                }

                .bb_2 {
                    flex: 1;

                }

                .bb_3 {
                    flex: 1;

                    div {
                        width: 60px;
                        height: 20px;
                        background: #E1F0FF;
                        border-radius: 6px 6px 6px 6px;
                        font-weight: 500;
                        font-size: 12px;
                        color: #2992FF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .bb_4 {
                    flex: 1;

                    div {
                        width: fit-content;
                        height: 20px;
                        background: #D7FFE6;
                        border-radius: 6px 6px 6px 6px;
                        font-weight: 500;
                        font-size: 12px;
                        color: #27C189;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .bb_5 {
                    flex: 1;

                    .b5img {
                        width: 80px;
                        height: 60px;
                    }
                }

                .bb_6 {
                    flex: 2;
                    // width: 260px;
                    font-weight: 500;
                    font-size: 14px;
                    color: #252525;
                    line-height: 26px;

                    .bb6 {
                        width: 100%;
                        height: 50px;
                    }
                }

                .bb_7 {
                    flex: 2;
                    // width: 180px;
                    font-weight: 500;
                    font-size: 14px;
                    color: #252525;
                }

                .bb_8 {
                    flex: 2;
                    // width: 220px;
                    display: flex;
                    align-items: center;

                    .bb8_btn1 {
                        font-weight: 500;
                        font-size: 13px;
                        color: #2992FF;
                        margin-right: 15px;
                        cursor: pointer;
                    }

                    .bb8_btn2 {
                        font-weight: 500;
                        font-size: 13px;
                        color: #CF1400;
                        cursor: pointer;

                    }
                }
            }
        }
    }
}
</style>
